var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemIconImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 6H5C4.44772 6 4 6.44772 4 7V25C4 25.5523 4.44772 26 5 26H27C27.5523 26 28 25.5523 28 25V7C28 6.44772 27.5523 6 27 6Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21L10.2875 14.7125C10.3805 14.618 10.4915 14.543 10.6138 14.4918C10.7361 14.4406 10.8674 14.4142 11 14.4142C11.1326 14.4142 11.2639 14.4406 11.3862 14.4918C11.5085 14.543 11.6195 14.618 11.7125 14.7125L17.2875 20.2875C17.3805 20.382 17.4915 20.457 17.6138 20.5082C17.7361 20.5595 17.8674 20.5858 18 20.5858C18.1326 20.5858 18.2639 20.5595 18.3862 20.5082C18.5085 20.457 18.6195 20.382 18.7125 20.2875L21.2875 17.7125C21.3805 17.618 21.4915 17.543 21.6138 17.4918C21.7361 17.4406 21.8674 17.4142 22 17.4142C22.1326 17.4142 22.2639 17.4406 22.3862 17.4918C22.5085 17.543 22.6195 17.618 22.7125 17.7125L28 23",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14C20.3284 14 21 13.3284 21 12.5C21 11.6716 20.3284 11 19.5 11C18.6716 11 18 11.6716 18 12.5C18 13.3284 18.6716 14 19.5 14Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemIconImages);
export default __webpack_public_path__ + "static/media/itemIconImages.9f68b3a7d96cce2be798af5ddaf3e792.svg";
export { ForwardRef as ReactComponent };